import '../../commonComp/profileIba/profileiba.scss';
import personImge from '../../../../asset/images/ibaimages/personImge.svg';
import rightArrowIba from '../../../../asset/images/ibaimages/rightArrowIba.svg';
import { useNavigate } from 'react-router-dom';
import { getInitials } from '../../../../CommonMethhods/CommonMethods';

const ProfileIba = ({ overviewDetails, performerKey = "top_performer_1" }) => {
    const performer = overviewDetails
    // const performer = overviewDetails?.top_performers?.[performerKey];
    const navigate = useNavigate();

    if (!performer) return null;

    console.log(performer, "performer");
    

    const moveAgentPerformance = () => {
        localStorage.removeItem("sapCode");
        
        if (performerKey === "top_performer_2") {
           const userId = performer?.topPerformerTalkTimeUserId;
           const userName = performer?.topPerformerUserNameTalkTime;
           
            if(userId !== "" || undefined){
                localStorage.setItem("sapCode", userId);
            }
            if(userName !== "" || undefined){
                localStorage.setItem("userNameIBA", userName);
            }
        } else {
           const userIdNew = performer?.topPerformerUserId;
           const userNameNew = performer?.topPerformerUserName;
            if(userIdNew !== "" || undefined){
                localStorage.setItem("sapCode", userIdNew);
            }
             if(userNameNew !== "" || undefined){
                localStorage.setItem("userNameIBA", userNameNew);
            }
        }
            
        navigate("/performance-reports");
        };
    

    return (
        <div className="top-performer-card">
            <div className="card-header-iba">
                <span className="badge">Top Performer</span>
                <img src={rightArrowIba} 
                className='arrow-icon' 
                alt="rightArrowIba" 
                onClick={moveAgentPerformance} />
            </div>

            <div className="card-body">
                {performerKey === "top_performer_2" ?
                    <div className="avatar-section">
                        <div className='show-initial'>
                            <span className='init-text'>
                                {getInitials(performer.topPerformerUserNameTalkTime || "N A")}</span>
                        </div>
                        {/* <img src={personImge} alt="Top Performer" className="avatar" /> */}
                        <div className="name">{performer.topPerformerUserNameTalkTime || "N/A"}</div>
                    </div>
                    : <div className="avatar-section">
                        <div className='show-initial'>
                            <span className='init-text'>{getInitials(performer.topPerformerUserName || "N A")}</span>
                        </div>
                        <div className="name">{performer.topPerformerUserName || "N/A"}</div>
                    </div>
                }

                <div className="stats">
                    {performerKey === "top_performer_2" ?
                        <div>
                            <span>Total Talk time:</span>{" "}
                            <b className="link">{performer.topPerformerTotalTalkTime || 0} Mins</b>
                        </div>
                        :
                        <div>
                            <span>Accounts Opened:</span>{" "}
                            <b className="link">{performer.totalAccountsOpened || 0}</b>
                        </div>
                    }
                    {performerKey === "top_performer_2" ? (
                        <div>
                            <span>Total Leads:</span>{" "}
                            <b className="link">{performer.totalTalkTimeNumberofLeads || 0}</b>
                        </div>
                    ) : (
                        <div>
                            <span>Total Leads:</span>{" "}
                            <b className="link">{performer.totalNumberofLeads || 0}</b>
                        </div>
                    )}

                    {performerKey === "top_performer_2" ? (
                        <div>
                            <span>Total Converted:</span>{" "}
                            <b className="link">{performer.totalConverted || 0}</b>
                        </div>
                    ) : (
                        <div>
                            <span>Total Rejected:</span>{" "}
                            <b className="link">{performer.totalRejected || 0}</b>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProfileIba;
